// extracted by mini-css-extract-plugin
export default {"signature":"Pgm06s96dm9MGcdkERiA","title":"JtzemSWGh_4OkoG6w0Hv"};